"use client";
import React, { useEffect, useRef } from "react";

interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  style?: React.CSSProperties;
}

const AnimatedSection: React.FC<AnimatedSectionProps> = ({
  children,
  className = "",
  delay = 0,
  style,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              el.classList.add("appear-visible");
              el.classList.remove("appear-hidden");
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);

  return (
    <div data-component-id="src/components/AnimatedSection.tsx:43:4" data-component-path="src/components/AnimatedSection.tsx" data-component-line="43" data-component-end-line="45" data-component-file="AnimatedSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" ref={ref} className={`appear-hidden ${className}`} style={style}>
      {children}
    </div>
  );
};

export default AnimatedSection;
